export const isEmpty = (obj: object): boolean => {
  return Object.entries(obj).length === 0;
};
